import * as t from 'io-ts'
import fetchApi from '../fetch-api'

const investorsCodec = t.array(t.type({
  _id: t.string,
  investorID: t.string,
  name: t.string,
  tags: t.array(t.string),
  email: t.string,
  phone: t.string,
  dob: t.string,
  position: t.string,
  linkedin: t.string,
  profileImage: t.string,
  investments: t.array(t.unknown),
}))
type InvestorsPropsT ={
	invIDs: string
}

export const getInvestorsById = (props: InvestorsPropsT) => {
  const { invIDs } = props
  return {
    queryKey: ['GET_INVESTOR_BY_QUERY', invIDs],
    queryFn: () =>
      fetchApi({
				service:"core-service",
        headers:{method: 'GET'},
        pathname: `/investors?investorIDs=${invIDs}`,
        codec: investorsCodec
      }),
  }
}
